import type { UseSelectDto, UsesSelectDto } from '@@types/api.types';
import { useAuth0 } from '@auth0/auth0-react';
import type { ApiErrorWrapper } from '@hooks/api.hook';
import { useApi } from '@hooks/api.hook';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';

export const useGetUses = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = isAuthenticated;

  return useQuery<UseSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<UsesSelectDto>({ path: '/v1/data/uses' });
      return result.uses;
    },
    queryKey: queryKeys.use.getUses,
  });
};
